import * as Preferences from "./preference";
import {
  PreferenceElementWithCurrentValue,
  ConfigurationRegistry,
  Configuration
} from "./preferenceConfigurationConst";
import { PreferenceModel, PreferenceService } from "../sdServices/preferenceSvc";
import { FlightingService } from "../sdServices/flightingSvc";

/**
 * Preference service to assist PreferenceConfigurationConst and PreferenceService in combining of preference element configs with current values for utilization in controller
 */
export class UIService {
  // @ngInject
  constructor(
    private preferenceService: PreferenceService,
    private preferenceConfigurationRegistry: ConfigurationRegistry,
    private flightingService: FlightingService
  ) {}
  /**
   * Returns a complete list Preference Elements based on Pane Item Title
   */
  public getPreferenceElementsWithCurrentValue(
    sectionConfigurationTitle: string
  ): ng.IPromise<PreferenceElementWithCurrentValue[]> {
    let filteredConfig: Configuration = angular.copy(
      this.preferenceConfigurationRegistry.configurations.filter(function (configuration: Configuration) {
        return configuration.sectionConfiguration.title == sectionConfigurationTitle;
      })[0]
    );
    let preferenceElementsWithCurrentValue: PreferenceElementWithCurrentValue[] = [];
    let flights = this.flightingService.getAllEnabledFlights();

    return this.preferenceService
      .getPreference(filteredConfig.sectionConfiguration.appId, filteredConfig.sectionConfiguration.sectionId)
      .then((preferences) => {
        filteredConfig.preferenceElements.forEach((currentElement) => {
          if (!currentElement.flightNameForElement || flights.includes(currentElement.flightNameForElement)) {
            preferenceElementsWithCurrentValue.push(
              this.getPreferenceElementWithCurrentValue(currentElement, preferences)
            );
          }
        });

        return preferenceElementsWithCurrentValue;
      });
  }

  private getPreferenceElementWithCurrentValue(
    currentElement: Preferences.PreferenceElement,
    preferences: PreferenceModel
  ) {
    let currentValue: any;
    if (currentElement instanceof Preferences.InteractablePreferenceElement) {
      let preference = preferences.content[currentElement.preferenceKey];
      if (currentElement instanceof Preferences.PreferenceSelectMenu) {
        let selectMenuElement = <Preferences.PreferenceSelectMenu>currentElement;
        let matchingPreferenceOption = selectMenuElement.preferenceOptions.find((p) => p && preference == p.value);
        selectMenuElement.initialValue = {
          name: matchingPreferenceOption ? matchingPreferenceOption.name : undefined,
          value: preference
        };
        currentValue = angular.copy(selectMenuElement.initialValue);
      } else {
        let preferenceLower = preference.toLowerCase();
        if (preferenceLower == "true" || preferenceLower == "false") {
          currentValue = currentElement.initialValue = preferenceLower == "true";
        } else {
          currentElement.initialValue = preference;
          currentValue = preference;
        }
      }
    }

    return { currentValue: currentValue, configured: currentElement };
  }
}
